export default __webpack_public_path__ + "static/media/ezeeTunai_cashback.21426c94.svg";